module.exports = __webpack_public_path__ + "img/stripe.c9bc22d3.svg";